import isInIframe from './isInIframe'

export default isInIframe
